import TamanioManagementPage from '../pages/TamanioManagementPage'

const routes = [
    { name: 'TamanioManagementPage', path: '/tamanio-management', component: TamanioManagementPage },
]

export default routes;
